import { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';

const Circle = ({ percent }) => {

  const radius = 80;
  const stroke = 12;
  const normalizedRadius = radius - stroke * 0.6;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (percent / 100) * circumference;

  return (
    <svg height={radius * 2} width={radius * 2}>
      <circle
        stroke="#E5E7EB"
        fill="transparent"
        strokeWidth={stroke}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
      <circle
        stroke="#6366F1"
        fill="transparent"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeDasharray={`${circumference} ${circumference}`}
        style={{
          strokeDashoffset,
          transition: 'stroke-dashoffset 1.5s ease-in-out',
        }}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
      <text
        x="50%"
        y="50%"
        dominantBaseline="middle"
        textAnchor="middle"
        className="fill-gray-800 font-bold text-lg"
      >
        {percent}%
      </text>
    </svg>
  );
};

export default function Languages() {
  const { content } = useContext(LanguageContext);

  return (
    <div id="languages" className="min-h-screen flex flex-col items-center justify-center bg-white font-dosis"
    >
      <h1 className="text-5xl font-bold mb-14">
        {content.languages.title}
      </h1>

    <div className="grid grid-cols-2 md:grid-cols-3 gap-16">
        {content.languages.list.map((lang, index) => (
          <div
            key={index}
            className="flex flex-col items-center group"
          >
            <Circle percent={lang.percent} />

            <h3 className="mt-5 text-xl font-semibold">
              {lang.name}
            </h3>

            <span className="text-base text-gray-500">
              {lang.level}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
